<template>
  <span
    class="icon icon-with-tooltip"
    :class="{
      [`icon-${icon}`]: icon
    }"
    :data-tooltip="text"
    :data-tooltip-replace-params="textReplace"
  />
</template>

<script setup>
defineProps({
	icon: {
		type: String,
		required: true
	},
	text: {
		type: String,
		required: true
	},
	textReplace: {
		type: [String, null],
		default: null
	}
});

</script>

<style lang="scss">

.filterTooltip {
	display: none;
	position: absolute;
	padding: 1.2rem 1.4rem;
	top: calc(100% + 1rem);
	right: -1rem;
	width: 18.4rem;
	background-color: $white;
	box-shadow: $thinBoxShadow;
	border-radius: $borderRadius-xs;
	border: 0.2rem solid $main-border-color;

	@include breakpoint_down(md) {
		&.filterTooltip--cabinBaggageIncluded {
			width: 25.6rem;
			right: -8rem;

			&.filterTooltip--visible {
				&::before {
					right: 7.7rem;
				}

				&::after {
					right: 7.8rem;
				}
			}
		}
	}

	@include breakpoint_up(md) {
		width: 23.6rem;
		left: -1.1rem;
		right: unset;
	}

	@include breakpoint_up(lg) {
		z-index: 9999;
	}
}

.filterTooltip--climateCompensation {
	width: 20.9rem;
	border-color: $color-green-500;

	.filter-symbol {
		display: none;
	}
}

.filterTooltip--visible {
	display: inline-block;

	&::before {
		position: absolute;
		content: "";
		top: -1.4rem;
		right: 0.7rem;;
		border-left: .7rem solid transparent;
		border-right: .7rem solid transparent;
		border-bottom: 1.2rem solid $main-border-color;
		width: 0;
		height: 0;
		z-index: -1;

		@include breakpoint_up(md) {
			left: 0.8rem;
			right: unset;
		}
	}

	&::after {
		position: absolute;
		content: "";
		top: -1rem;
		right: 0.8rem;
		border-left: .6rem solid transparent;
		border-right: .6rem solid transparent;
		border-bottom: 1.1rem solid $white;
		width: 0;
		height: 0;
		z-index: -1;

		@include breakpoint_up(md) {
			left: 0.9rem;
			right: unset;
		}
	}

	&.filterTooltip--climateCompensation {
		&::before {
			border-bottom-color: $color-green-500;
		}
	}
}
</style>
